
const DiffFunction = (type, rowData, DiffData) => {
    const PK_KEY = "uniqueCode";
    let difftype = null;
    
    let refvalue = rowData?.find(vv => vv.name === PK_KEY)
    refvalue = refvalue?.value;
    
    let check = DiffData?.[type+"D"].diffUpd?.[refvalue]
    
    if(check) {
        difftype = "update";  
    } else {
        if(difftype === null) {
            difftype = DiffData?.[type+"D"].diffAdd.find(f => f === refvalue) && "add";
        }

    }

    return {type: difftype, data: check};
}

const DiffFunctionDeleteRow = (type, uniqueCode, _data) => {
    const targetData = _data?.[type+"D"]?.diffDel;
    if(targetData?.length > 0) {
        if(type.toString().toUpperCase() === "COMPOSITION") {
            const filtered = targetData.filter(f => f.uniqueCode.substr(13,1) === "C");
            return filtered;
        } else {
            const targetCode = uniqueCode.substr(0,13)
            const filtered = targetData.filter(f => f.uniqueCode.substr(0,13) === targetCode);
            return filtered;
        }
    } else {
        return [];
    }    
}

const DiffFunctionDeleteSO = (subData, typeData) => {
    if(typeData.length < 1) {
        return {so: [], data: []}
    };
    const sorted = subData?.sort((a,b) => {
        if (a.uniqueCode > b.uniqueCode) return 1
        if (a.uniqueCode < b.uniqueCode) return -1
        return 0
    });
    const typeD = sorted.map(so => {
        const uniqueCode = so.uniqueCode.toString().substr(0,13);
        const filtered = typeData.filter(f => f.uniqueCode.toString().substr(0,13) === uniqueCode);
        return filtered;
    })
    
    return {so: sorted, data: typeD};
}

export { DiffFunction, DiffFunctionDeleteRow, DiffFunctionDeleteSO };